<tui-input
  [formControl]="control.control"
  [tuiTextfieldCleaner]="true"
  [tuiTextfieldLabelOutside]="true"
  [tuiTextfieldSize]="'s'"
  [tuiTextfieldIcon]="icon"
>
  {{ placeholder }}
</tui-input>
<ng-template #icon>
  <tui-svg class="wo-search-field__icon" src="tuiIconSearchLarge" />
</ng-template>
